/* Felinora — interacciones propias */
(function () {
  if (window.__flInit) return;
  window.__flInit = true;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.fl-reveal:not(.fl-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('fl-visible'); });
      return;
    }
    if (!window.__flObserver) {
      window.__flObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('fl-visible'); window.__flObserver.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { window.__flObserver.observe(el); });
  }

  function initColors(root) {
    (root || document).querySelectorAll('[data-fl-colors]').forEach(function (wrap) {
      if (wrap.__flDone) return; wrap.__flDone = true;
      var swatches = wrap.querySelectorAll('.fl-swatch');
      var imgs = wrap.querySelectorAll('.fl-colors__stage img');
      var name = wrap.querySelector('[data-fl-color-name]');
      var btn = wrap.querySelector('[data-fl-color-btn]');
      swatches.forEach(function (sw, i) {
        sw.addEventListener('click', function () {
          swatches.forEach(function (s) { s.classList.remove('is-active'); s.setAttribute('aria-pressed', 'false'); });
          imgs.forEach(function (im) { im.classList.remove('is-active'); });
          sw.classList.add('is-active'); sw.setAttribute('aria-pressed', 'true');
          if (imgs[i]) imgs[i].classList.add('is-active');
          if (name) name.textContent = sw.dataset.name;
          if (btn && sw.dataset.url) btn.setAttribute('href', sw.dataset.url);
        });
      });
    });
  }

  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    format = format || '{{amount_with_comma_separator}} €';
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/, withDot);
  }

  function initProduct(root) {
    (root || document).querySelectorAll('[data-fl-product]').forEach(function (pdp) {
      if (pdp.__flDone) return; pdp.__flDone = true;
      var dataEl = pdp.querySelector('[data-fl-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var fmt = pdp.dataset.moneyFormat;
      var idInput = pdp.querySelector('input[name="id"]');
      var priceEl = pdp.querySelectorAll('[data-fl-price]');
      var compareEl = pdp.querySelector('[data-fl-compare]');
      var saleEl = pdp.querySelector('[data-fl-sale]');
      var addBtns = pdp.querySelectorAll('[data-fl-add]');
      var addLabel = pdp.dataset.addLabel, soldLabel = pdp.dataset.soldLabel;
      var mainImg = pdp.querySelector('.fl-gallery__main img');
      var thumbs = pdp.querySelectorAll('.fl-gallery__thumb');

      var counter = pdp.querySelector('.fl-gallery__count');
      var current = 0;
      thumbs.forEach(function (t, i) { if (t.classList.contains('is-active')) current = i; });
      if (counter && thumbs.length) counter.textContent = (current + 1) + ' / ' + thumbs.length;

      function showMedia(src, srcset, thumb) {
        if (!mainImg || !src) return;
        mainImg.style.opacity = '0.3';
        var tmp = new Image();
        tmp.onload = function () {
          // Quitar srcset/sizes: si no, el navegador sigue mostrando la primera foto cargada
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = src;
          if (srcset) mainImg.srcset = srcset;
          mainImg.style.opacity = '1';
        };
        tmp.src = src;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        if (thumb) {
          thumb.classList.add('is-active');
          current = Array.prototype.indexOf.call(thumbs, thumb);
          if (thumb.scrollIntoView && window.innerWidth < 750) thumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }
        if (counter && thumbs.length) counter.textContent = (current + 1) + ' / ' + thumbs.length;
      }
      function go(step) {
        if (!thumbs.length) return;
        var n = (current + step + thumbs.length) % thumbs.length;
        showMedia(thumbs[n].dataset.src, null, thumbs[n]);
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { showMedia(t.dataset.src, null, t); });
      });
      var prev = pdp.querySelector('.fl-gallery__nav--prev');
      var next = pdp.querySelector('.fl-gallery__nav--next');
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      var mainBox = pdp.querySelector('.fl-gallery__main');
      if (mainBox) {
        var x0 = null;
        mainBox.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        mainBox.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
          x0 = null;
        });
      }

      function update() {
        var selected = [];
        pdp.querySelectorAll('.fl-option').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          if (c) selected.push(c.value);
          var lbl = fs.querySelector('[data-fl-selected]');
          if (lbl && c) lbl.textContent = c.value;
        });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === selected[i]; }); });
        addBtns.forEach(function (b) {
          b.disabled = !v || !v.available;
          var span = b.querySelector('span') || b;
          span.textContent = !v ? soldLabel : (v.available ? addLabel : soldLabel);
        });
        if (!v) return;
        if (idInput) idInput.value = v.id;
        priceEl.forEach(function (p) { p.textContent = money(v.price, fmt); });
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price, fmt); compareEl.hidden = false; }
          else compareEl.hidden = true;
        }
        if (saleEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) { saleEl.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + ' %'; saleEl.hidden = false; }
          else saleEl.hidden = true;
        }
        if (v.featured_image) {
          var t = pdp.querySelector('.fl-gallery__thumb[data-media-id="' + v.featured_media_id + '"]');
          showMedia(v.featured_image, null, t);
        }
        if (window.history && window.history.replaceState && pdp.dataset.updateUrl === 'true') {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      pdp.querySelectorAll('.fl-option input').forEach(function (inp) { inp.addEventListener('change', update); });

      var qty = pdp.querySelector('.fl-qty input');
      // Selector de pack (1 collar / 3 collares con el 3x2)
      var packs = pdp.querySelectorAll('.fl-pack');
      function markPack(n) {
        packs.forEach(function (p) {
          var on = String(p.dataset.qty) === String(n);
          p.classList.toggle('is-active', on);
          p.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      }
      packs.forEach(function (p) {
        p.addEventListener('click', function () { if (qty) qty.value = p.dataset.qty; markPack(p.dataset.qty); });
      });
      if (qty) qty.addEventListener('input', function () { markPack(qty.value); });
      pdp.querySelectorAll('[data-fl-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(qty.value || '1', 10) + parseInt(b.dataset.flQty, 10);
          qty.value = Math.max(1, n);
          markPack(qty.value);
        });
      });

      // Añadir al carrito con el cajón de Dawn si existe; si no, envío normal del formulario
      var form = pdp.querySelector('form[action*="/cart/add"]');
      var errEl = pdp.querySelector('.fl-pdp__error');
      if (form) {
        form.addEventListener('submit', function (e) {
          var drawer = document.querySelector('cart-drawer');
          if (!window.fetch || !drawer || typeof drawer.renderContents !== 'function') return;
          e.preventDefault();
          var fd = new FormData(form);
          fd.append('sections', 'cart-drawer,cart-icon-bubble');
          fd.append('sections_url', window.location.pathname);
          addBtns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
          }).then(function (r) { return r.json(); }).then(function (res) {
            if (res.status) { if (errEl) errEl.textContent = res.description || res.message; return; }
            if (errEl) errEl.textContent = '';
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          }).catch(function () { form.submit(); })
            .finally(function () { addBtns.forEach(function (b) { b.removeAttribute('aria-busy'); }); });
        });
      }

      // Barra fija de compra en móvil
      var sticky = pdp.querySelector('.fl-sticky-buy');
      var mainAdd = pdp.querySelector('.fl-add');
      if (sticky && mainAdd && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0];
          sticky.classList.toggle('is-shown', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(mainAdd);
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        });
      }
    });
  }

  function initAll(root) { initReveal(root); initColors(root); initProduct(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
